import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { pathConfig } from "../../../config/path-config";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, `${pathConfig.staticsPath}/assets/i18n/`, ".json");
}
